module.exports = __webpack_public_path__ + "static/img/Tile@2x.b0da9be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Tile@2x.png
// module id = 408
// module chunks = 1